module.exports = __webpack_public_path__ + "static/media/magnifier.469b84e8.svg";